import { SessionSence } from 'models/integrations'
import api from '../..'

export const senceCurrentSession = (senceCode: string) => {
  return api
    .post<{
      valid: boolean
      session: SessionSence
    }>('integrations/sence/current_session', {
      sence_code: senceCode,
    })
    .then((response) => response.data)
}

export default senceCurrentSession
